import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import { gsap } from 'gsap'
import { down, only } from 'styled-breakpoints'
import { MOBILE, TABLET } from '../../lib/constant'

export default function MainSection() {
	const sectionRef = useRef(null)

	useEffect(() => {
		if (!sectionRef.current) {
			return
		}

		const timeline = gsap.timeline({
			scrollTrigger: {
				trigger: sectionRef.current,
				toggleActions: 'play pause pause pause',
				start: '-=100px top',
			},
		})

		timeline.fromTo(
			'.color-bar',
			{
				y: -700,
			},
			{
				delay: (index) => index * 0.025,
				y: 0,
				autoAlpha: 1,
				ease: 'Power3.easeOut',
			}
		)

		return () => {
			timeline.kill()
		}
	}, [])

	return (
		<Section ref={sectionRef}>
			<Wrapper>
				<Shape>
					<ShapeWrapper>
						<svg
							width="1945"
							height="2025"
							viewBox="0 0 1945 2025"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g filter="url(#filter0_d)" className="color-bar">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M871.304 386.528C899.278 386.528 921.955 409.205 921.955 437.179L921.955 1829.39C921.955 1857.37 899.278 1880.04 871.304 1880.04C843.33 1880.04 820.653 1857.37 820.653 1829.39L820.653 437.179C820.653 409.205 843.33 386.528 871.304 386.528Z"
									fill="#FFDC60"
								/>
							</g>
							<g filter="url(#filter1_d)" className="color-bar">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M769.738 34.2517C797.712 34.2517 820.39 56.929 820.39 84.9028L820.389 1477.12C820.389 1505.09 797.712 1527.77 769.738 1527.77C741.765 1527.77 719.087 1505.09 719.087 1477.12L719.087 84.9029C719.087 56.929 741.765 34.2517 769.738 34.2517Z"
									fill="#B9FF60"
								/>
							</g>
							<g filter="url(#filter2_d)" className="color-bar">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M1074.44 507.283C1102.41 507.283 1125.09 529.96 1125.09 557.934L1125.09 1950.15C1125.09 1978.12 1102.41 2000.8 1074.44 2000.8C1046.46 2000.8 1023.78 1978.12 1023.78 1950.15L1023.78 557.934C1023.78 529.96 1046.46 507.283 1074.44 507.283Z"
									fill="#D84576"
								/>
							</g>
							<g filter="url(#filter3_d)" className="color-bar">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M1175.21 181.741C1203.18 181.741 1225.86 204.418 1225.86 232.392L1225.86 1624.61C1225.86 1652.58 1203.18 1675.26 1175.21 1675.26C1147.23 1675.26 1124.56 1652.58 1124.56 1624.61L1124.56 232.392C1124.56 204.418 1147.23 181.741 1175.21 181.741Z"
									fill="#B90C46"
								/>
							</g>
							<g filter="url(#filter4_d)" className="color-bar">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M973.379 21.9802C1001.35 21.9802 1024.03 44.6575 1024.03 72.6313L1024.03 1464.85C1024.03 1492.82 1001.35 1515.5 973.379 1515.5C945.405 1515.5 922.728 1492.82 922.728 1464.85L922.728 72.6314C922.728 44.6575 945.405 21.9802 973.379 21.9802Z"
									fill="#FF6D60"
								/>
							</g>
							<defs>
								<filter
									id="filter0_d"
									x="101.565"
									y="364.548"
									width="1539.48"
									height="1539.48"
									filterUnits="userSpaceOnUse"
									colorInterpolationFilters="sRGB"
								>
									<feFlood floodOpacity="0" result="BackgroundImageFix" />
									<feColorMatrix
										in="SourceAlpha"
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
									/>
									<feOffset dy="1" />
									<feGaussianBlur stdDeviation="1" />
									<feColorMatrix
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
									/>
									<feBlend
										mode="normal"
										in2="BackgroundImageFix"
										result="effect1_dropShadow"
									/>
									<feBlend
										mode="normal"
										in="SourceGraphic"
										in2="effect1_dropShadow"
										result="shape"
									/>
								</filter>
								<filter
									id="filter1_d"
									x="0"
									y="12.2715"
									width="1539.48"
									height="1539.48"
									filterUnits="userSpaceOnUse"
									colorInterpolationFilters="sRGB"
								>
									<feFlood floodOpacity="0" result="BackgroundImageFix" />
									<feColorMatrix
										in="SourceAlpha"
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
									/>
									<feOffset dy="1" />
									<feGaussianBlur stdDeviation="1" />
									<feColorMatrix
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
									/>
									<feBlend
										mode="normal"
										in2="BackgroundImageFix"
										result="effect1_dropShadow"
									/>
									<feBlend
										mode="normal"
										in="SourceGraphic"
										in2="effect1_dropShadow"
										result="shape"
									/>
								</filter>
								<filter
									id="filter2_d"
									x="304.697"
									y="485.303"
									width="1539.48"
									height="1539.48"
									filterUnits="userSpaceOnUse"
									colorInterpolationFilters="sRGB"
								>
									<feFlood floodOpacity="0" result="BackgroundImageFix" />
									<feColorMatrix
										in="SourceAlpha"
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
									/>
									<feOffset dy="1" />
									<feGaussianBlur stdDeviation="1" />
									<feColorMatrix
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
									/>
									<feBlend
										mode="normal"
										in2="BackgroundImageFix"
										result="effect1_dropShadow"
									/>
									<feBlend
										mode="normal"
										in="SourceGraphic"
										in2="effect1_dropShadow"
										result="shape"
									/>
								</filter>
								<filter
									id="filter3_d"
									x="405.469"
									y="159.761"
									width="1539.48"
									height="1539.48"
									filterUnits="userSpaceOnUse"
									colorInterpolationFilters="sRGB"
								>
									<feFlood floodOpacity="0" result="BackgroundImageFix" />
									<feColorMatrix
										in="SourceAlpha"
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
									/>
									<feOffset dy="1" />
									<feGaussianBlur stdDeviation="1" />
									<feColorMatrix
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
									/>
									<feBlend
										mode="normal"
										in2="BackgroundImageFix"
										result="effect1_dropShadow"
									/>
									<feBlend
										mode="normal"
										in="SourceGraphic"
										in2="effect1_dropShadow"
										result="shape"
									/>
								</filter>
								<filter
									id="filter4_d"
									x="203.641"
									y="0"
									width="1539.48"
									height="1539.48"
									filterUnits="userSpaceOnUse"
									colorInterpolationFilters="sRGB"
								>
									<feFlood floodOpacity="0" result="BackgroundImageFix" />
									<feColorMatrix
										in="SourceAlpha"
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
									/>
									<feOffset dy="1" />
									<feGaussianBlur stdDeviation="1" />
									<feColorMatrix
										type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
									/>
									<feBlend
										mode="normal"
										in2="BackgroundImageFix"
										result="effect1_dropShadow"
									/>
									<feBlend
										mode="normal"
										in="SourceGraphic"
										in2="effect1_dropShadow"
										result="shape"
									/>
								</filter>
							</defs>
						</svg>
					</ShapeWrapper>
				</Shape>
				<Title>
					타고가와 <br className="br" /> 함께하는 <br /> 즐거운{' '}
					<br className="br" /> 라이딩
				</Title>
			</Wrapper>
		</Section>
	)
}

const Section = styled.section`
	overflow: hidden;
`

const Wrapper = styled.div`
	position: relative;
	padding: 192px 0;
	margin: 0 auto;
	max-width: 1180px;

	${down(TABLET)} {
		padding: 136px 0;
	}
	${only(TABLET)} {
		padding-bottom: 240px;
	}
`

const Shape = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	width: 640px;
	height: 640px;

	${down(TABLET)} {
		width: 550px;
		height: 550px;
	}
`

const ShapeWrapper = styled.div`
	transform: rotate(45deg) translate(-1%, 17%);
	position: absolute;
	bottom: 0;
	left: 0;

	.color-bar {
		opacity: 0;
	}
	${down(TABLET)} {
		left: 160px;
		bottom: 60px;
		> svg {
			width: 1200px;
			height: 1200px;
		}
	}
`

const Title = styled.h1`
	font-size: 128px;
	line-height: 128px;
	font-weight: 700;
	text-align: center;
	position: relative;
	z-index: 2;
	> .br {
		display: none;
	}
	${down(TABLET)} {
		font-size: 64px;
		line-height: 72px;
	}
	${down(MOBILE)} {
		> .br {
			display: block;
		}
	}
`
